import { Col, Row, Table } from 'reactstrap';
import { ContentBlock } from '../../Shared/Content/ContentBlock';
import { ContentHeading } from '../../Shared/Content/ContentHeading';
import { ContentBody } from '../../Shared/Content/ContentBody';

export const OperatingEfficiency = () => {
    return (
        <div id="operating-efficiency">
            <ContentBlock className="evFundamentalsSection">
                <ContentHeading title="Battery Electric Vehicle Operating Efficiency" />
                <ContentBody>
                    <div className="heading5">For most vehicles, there is a comparable battery electric replacement. Each of these vehicles operates differently when it comes to range and efficiency. When compared to their gas-powered counterparts, the operating efficiency of battery electric vehicles (BEVs) in miles per gasoline gallon equivalent (MPGGE) is two to four times greater than conventional vehicles.</div>
                    <Row className="tableBlock">
                        <Col>
                            <Table responsive striped className="BEVOperatingEfficiency">
                                <caption>BEV Operating Efficiency</caption>
                                <thead>
                                    <tr>
                                        <th className="text-left">Vehicle Type</th>
                                        <th>Range<sup className={'super-footnote'}>1</sup></th>
                                        <th>Battery Size</th>
                                        <th>MPGGE:<br/>Battery Electric Vehicle<sup className={'super-footnote'}>1</sup></th>
                                        <th>MPGGE:<br/>Conventional Vehicle<sup className={'super-footnote'}>1</sup></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="text-left">Sedan</td>
                                        <td>30-400 miles</td>
                                        <td>30-110 kWh</td>
                                        <td>87.5</td>
                                        <td>26.2</td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">Pickup Truck</td>
                                        <td>200-500 miles</td>
                                        <td>120-200 kWh</td>
                                        <td>49.2</td>
                                        <td>16.4</td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">SUV</td>
                                        <td>200-330 miles</td>
                                        <td>65-95 kWh</td>
                                        <td>60.3</td>
                                        <td>20.1</td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">Van</td>
                                        <td>60-190 miles</td>
                                        <td>40-100 kWh</td>
                                        <td>41.2</td>
                                        <td>14.5</td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">Refuse Truck</td>
                                        <td>80-250 miles</td>
                                        <td>160-480 kWh</td>
                                        <td>4.8</td>
                                        <td>2</td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">Shuttle Bus</td>
                                        <td>60-200 miles</td>
                                        <td>40-160 kWh</td>
                                        <td>23.5</td>
                                        <td>9</td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">Transit Bus</td>
                                        <td>15-330 miles</td>
                                        <td>75-660 kWh</td>
                                        <td>10.5</td>
                                        <td>5</td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">School Bus</td>
                                        <td>65-155 miles</td>
                                        <td>70-220 kWh</td>
                                        <td>19.6</td>
                                        <td>8</td>
                                    </tr>
                                </tbody>
                            </Table>

                            <div className="disclaimer">
                                <sup className={'super-footnote'}>1</sup>Nominal values, not accounting for external factors such as temperature and driving habits
                                <br />Sources: Argonne National Laboratory, FuelEconomy.gov
                            </div>
                            <div className="referenceContent">
                                <p>Learn more at <a href="https://fueleconomy.gov" target="_blank" rel="noreferrer">FuelEconomy.gov</a> and the <a href="https://afdc.energy.gov/" target="_blank" rel="noreferrer">Alternative Fuels Data Center</a>.</p>
                            </div>
                        </Col>
                    </Row>
                </ContentBody>
            </ContentBlock>
        </div>
    );

};
